import { Text } from '~/@mid_ui/typography/Text'
import { cn } from '~/shadcn/lib/utils'

type Props = {
  message?: string
  className?: string
}

function NoRecords({ message, className }: Props) {
  return (
    <div
      className={cn(
        'flex flex-row items-center justify-start gap-10 mt-20',
        className
      )}>
      <Text className="font-semibold">{message ?? 'Žiadne záznamy'}</Text>
    </div>
  )
}

export { NoRecords }
